import { HttpClient } from "@angular/common/http";
import { Inject,Injectable } from "@angular/core";
import { ActivatedRouteSnapshot,Router,RouterStateSnapshot } from "@angular/router";
import { map,Observable,switchMap } from "rxjs";
import { RepositoryServiceToken } from "../services";
import { CommunityAuthService } from "../services/community-auth.service";
import { IRepositoryService } from "../services/i";
import { UserFilterType,UserFilterViewModel,UserViewModel } from "../view-models";

@Injectable()
export class UserResolver  {
    constructor(
        private router: Router,
        @Inject(RepositoryServiceToken) private repo: IRepositoryService,
        private authServ: CommunityAuthService,
        private http: HttpClient)
    {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserViewModel> {
        return this.authServ.isDoneLoading$
            .pipe(
                switchMap(u => {
                    const f = new UserFilterViewModel();
                    f.Type = UserFilterType.HawkId;
                    f.Page = 0;
                    f.HawkId = this.authServ.applicationUsername;
                    return this.repo.Page(UserViewModel, f);
                }),
                map(arr => arr[0])
            );
    }
}